import React, { useEffect, useMemo, useState } from 'react';
import { Box, Grid } from '@mui/material';
import Marquee from 'react-fast-marquee';
import { images } from '../../../config/images';
import PieChart from './PieChart';
import BarChart from './BarChart';
import './PieBarChart.css';
import { chartColors, getSizeColor, getUserRoleColor } from '../../../config/constantsColor';

const PieLineChart = ({ label, chartData, scanByData, counterfeitData, crossSellingData, sizeData, userRoleList }) => {
    const [selectedChart, setSelectedChart] = useState('pie');

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const shouldUseMarquee = (dataLength) => {
        if (dataLength > 5) return true;
        return screenWidth >= 820 && screenWidth < 1536;
    };

    const chartDataLength = chartData?.size_counts?.length || 0;
    const counterfeitLength = counterfeitData?.top_sizes?.length || 0;
    const crossSellingLength = crossSellingData?.top_sizes?.length || 0;
    const scanByLength = scanByData?.user_roles?.length || 0;

    const enableMarqueeChartData = shouldUseMarquee(chartDataLength);
    const enableMarqueeCounterfeit = shouldUseMarquee(counterfeitLength);
    const enableMarqueeCrossSelling = shouldUseMarquee(crossSellingLength);
    const enableMarqueeScanBy = shouldUseMarquee(scanByLength);

    return (
        <Box className="pie-bar-chart">
            {label === 'Scan By' ? (
                <>
                    <Box className="chart-selector">
                        <div className="d-flex justify-content-start align-items-center w-100">
                            <div className="d-flex align-items-center gap-3">
                                <div className="d-flex">
                                    <img
                                        src={selectedChart === "pie" ? images.pieChartBgImg : images.pieChart}
                                        alt=""
                                        className="graph-type-box chart-box"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setSelectedChart("pie")}
                                    />
                                    <img
                                        src={selectedChart === "bar" ? images.barChartBgImg : images.barChart}
                                        alt=""
                                        className="graph-type-box chart-box"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setSelectedChart("bar")}
                                    />
                                </div>
                            </div>
                        </div>
                    </Box>
                    <Box className="chart-content">
                        <Box className="scanBy-chart-row">
                            <Grid container>
                                <Grid item size={{ xs: 12, md: 4 }} className="grid-item">
                                    <div className="chart-column">
                                        <div className="chart-title">Scan By</div>
                                        {scanByData?.user_roles?.length > 0 ? (
                                            selectedChart === 'pie' ? (
                                                <PieChart data={scanByData} label="Scan By" sizeData={sizeData} userRoleList={userRoleList} />
                                            ) : (
                                                <BarChart data={scanByData} label="Scan By" sizeData={sizeData} userRoleList={userRoleList} />
                                            )
                                        ) : (
                                            <div className="no-data-container">
                                                <img
                                                    src={images.noDataFoundImg}
                                                    className="no-data-img"
                                                    alt="No Data Found"
                                                />
                                            </div>
                                        )}
                                        <Box className="chart-label">
                                            {enableMarqueeScanBy ? (
                                                <Marquee
                                                    gradient={false}
                                                    speed={40}
                                                    pauseOnHover={true}
                                                    direction="left"
                                                >
                                                    {scanByData?.user_roles?.map((item, index) => (
                                                        <div key={index}  className={`label-item ${enableMarqueeScanBy ? 'marquee-spacing' : ''}`}style={{ borderLeft: `4px solid ${getUserRoleColor(item.user_role, userRoleList)}` }}>
                                                            <div className='label-item-scan-type'>{item.user_role}</div>
                                                            <div className='label-item-scan-value'>
                                                                <span style={{ color: `${chartColors['Cross Selling']}` }}>PASS</span> {item.genuine_count}
                                                            </div>
                                                            <div className='label-item-scan-value'>
                                                                <span style={{ color: `${chartColors['Counterfeit']}` }}>FAIL</span> {item.counterfeit_count}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </Marquee>
                                            ) : (
                                                <div className="d-flex justify-content-between align-items-center">
                                                    {scanByData?.user_roles?.map((item, index) => (
                                                        <div key={index} className="label-item" style={{ borderLeft: `4px solid ${getUserRoleColor(item.user_role, userRoleList)}` }}>
                                                            <div className='label-item-scan-type'>{item.user_role}</div>
                                                            <div className='label-item-scan-value'>
                                                                <span style={{ color: `${chartColors['Cross Selling']}` }}>PASS</span> {item.genuine_count}
                                                            </div>
                                                            <div className='label-item-scan-value'>
                                                                <span style={{ color: `${chartColors['Counterfeit']}` }}>FAIL</span> {item.counterfeit_count}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, md: 4 }} className="grid-item">
                                    <div className="chart-column">
                                        <div className="chart-title">Top 5 Counterfeit Products</div>
                                        {counterfeitData?.top_sizes?.length > 0 ? (
                                            selectedChart === 'pie' ? (
                                                <PieChart data={counterfeitData} label="Top 5 Counterfeit Products" sizeData={sizeData} userRoleList={userRoleList}/>
                                            ) : (
                                                <BarChart data={counterfeitData} label="Top 5 Counterfeit Products" sizeData={sizeData} userRoleList={userRoleList} />
                                            )
                                        ) : (
                                            <div className="no-data-container">
                                                <img
                                                    src={images.noDataFoundImg}
                                                    className="no-data-img"
                                                    alt="No Data Found"
                                                />
                                            </div>
                                        )}
                                        <Box className="chart-label">
                                            {enableMarqueeCounterfeit ? (
                                                <Marquee
                                                    gradient={false}
                                                    speed={40}
                                                    pauseOnHover={true}
                                                    direction="left"
                                                >
                                                    {counterfeitData?.top_sizes?.map((item, index) => (
                                                        <div key={index}  className={`label-item ${enableMarqueeCounterfeit ? 'marquee-spacing' : ''}`} style={{ borderLeft: `4px solid ${getSizeColor(item.size, sizeData)}` }}>
                                                            <div className='label-item-size'>{item.size}</div>
                                                            <div className='label-item-value'>{item.count}</div>
                                                        </div>
                                                    ))}
                                                </Marquee>
                                            ) : (
                                                <div className="d-flex justify-content-between align-items-center">
                                                    {counterfeitData?.top_sizes?.map((item, index) => (
                                                        <div key={index} className="label-item" style={{ borderLeft: `4px solid ${getSizeColor(item.size, sizeData)}`, marginRight: '20px' }}>
                                                            <div className='label-item-size'>{item.size}</div>
                                                            <div className='label-item-value'>{item.count}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, md: 4 }} className="grid-item">
                                    <div className="chart-column">
                                        <div className="chart-title">Top 5 Cross Selling Products</div>
                                        {crossSellingData?.top_sizes?.length > 0 ? (
                                            selectedChart === 'pie' ? (
                                                <PieChart data={crossSellingData} label="Top 5 Cross Selling Products" sizeData={sizeData} userRoleList={userRoleList} />
                                            ) : (
                                                <BarChart data={crossSellingData} label="Top 5 Cross Selling Products" sizeData={sizeData} userRoleList={userRoleList} />
                                            )
                                        ) : (
                                            <div className="no-data-container">
                                                <img
                                                    src={images.noDataFoundImg}
                                                    className="no-data-img"
                                                    alt="No Data Found"
                                                />
                                            </div>
                                        )}
                                        <Box className="chart-label">
                                            {enableMarqueeCrossSelling ? (
                                                <Marquee
                                                    gradient={false}
                                                    speed={40}
                                                    pauseOnHover={true}
                                                    direction="left"
                                                >
                                                    {crossSellingData?.top_sizes?.map((item, index) => (
                                                        <div key={index} className={`label-item ${enableMarqueeCrossSelling ? 'marquee-spacing' : ''}`} style={{ borderLeft: `4px solid ${getSizeColor(item.size, sizeData)}` }}>
                                                            <div className='label-item-size'>{item.size}</div>
                                                            <div className='label-item-value'>{item.count}</div>
                                                        </div>
                                                    ))}
                                                </Marquee>
                                            ) : (
                                                <div className="d-flex justify-content-between align-items-center">
                                                    {crossSellingData?.top_sizes?.map((item, index) => (
                                                        <div key={index} className="label-item" style={{ borderLeft: `4px solid ${getSizeColor(item.size, sizeData)}`, marginRight: '20px' }}>
                                                            <div className='label-item-size'>{item.size}</div>
                                                            <div className='label-item-value'>{item.count}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </Box>
                                    </div>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </>
            ) : (
                <>
                    <Box className="chart-selector">
                        <div className="d-flex">
                            <img
                                src={selectedChart === "pie" ? images.pieChartBgImg : images.pieChart}
                                alt=""
                                className="graph-type-box chart-box"
                                style={{ cursor: "pointer" }}
                                onClick={() => setSelectedChart("pie")}
                            />
                            <img
                                src={selectedChart === "bar" ? images.barChartBgImg : images.barChart}
                                alt=""
                                className="graph-type-box chart-box"
                                style={{ cursor: "pointer" }}
                                onClick={() => setSelectedChart("bar")}
                            />
                        </div>
                    </Box>
                    <Box className="chart-content">
                        <Box className="chart-row">
                            {selectedChart === 'pie' ? (
                                <PieChart data={chartData} label={label} sizeData={sizeData} userRoleList={userRoleList} />
                            ) : (
                                <BarChart data={chartData} label={label} sizeData={sizeData} userRoleList={userRoleList} />
                            )}
                        </Box>
                    </Box>
                    <Box className="chart-label">
                        {enableMarqueeChartData ? (
                            <Marquee
                                gradient={false}
                                speed={40}
                                pauseOnHover={true}
                                direction="left"
                            >
                                {chartData?.size_counts?.map((item, index) => (
                                    <div key={index}  className={`label-item ${enableMarqueeChartData ? 'marquee-spacing' : ''}`} style={{ borderLeft: `4px solid ${getSizeColor(item.size, sizeData)}` }}>
                                        <div className='label-item-size'>{item.size}</div>
                                        <div className='label-item-value'>{item.count}</div>
                                    </div>
                                ))}
                            </Marquee>
                        ) : (
                            <div className="d-flex justify-content-between align-items-center">
                                {chartData?.size_counts?.map((item, index) => (
                                    <div key={index} className="label-item" style={{ borderLeft: `4px solid ${getSizeColor(item.size, sizeData)}`, marginRight: '20px' }}>
                                        <div className='label-item-size'>{item.size}</div>
                                        <div className='label-item-value'>{item.count}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </Box>
                </>
            )}
        </Box>
    );
};

export default PieLineChart;